
import { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // 当页面向下滚动超过300px时显示按钮
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {/* 手机版悬浮球 */}
      <button
        onClick={scrollToTop}
        className={`
          md:hidden fixed right-4 top-1/2 transform -translate-y-1/2 z-50
          w-12 h-12 bg-white/80 backdrop-blur-sm shadow-2xl
          rounded-full flex items-center justify-center
          text-[#847eba] hover:text-white hover:bg-[#847eba]
          transition-all duration-300 ease-in-out cursor-pointer
          border border-white/20
          ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'}
        `}
        style={{
          boxShadow: '0 8px 32px rgba(132, 126, 186, 0.2), 0 4px 16px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-up-line text-lg"></i>
        </div>
      </button>
    </>
  );
}
